import styled from 'styled-components';
import { colorWhite, mediaXs } from 'theme/theme-helper-selectors';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ContentText = styled.h3`
    font-size: 30px;
    font-weight: 400;
    line-height: 36px;
    text-align: center;
`;

export const ButtonBlock = styled.div`
    display: flex;
    flex-direction: row;
    padding: 20px 0px;
    gap: 10px;
    a {
        &:hover {
            color: ${colorWhite};
        }
    }
    @media (${mediaXs}) {
        flex-direction: column;
    }
`;
